import { Component, Input, OnInit } from '@angular/core';
import { AdvanceMortgageCalculatorComponent } from './advance-mortgage-calculator/advance-mortgage-calculator.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { PricingService } from 'src/app/service/pricing.service';

@Component({
  selector: 'app-mortgage-calculator',
  templateUrl: './mortgage-calculator.component.html',
  styleUrls: ['./mortgage-calculator.component.scss']
})
export class MortgageCalculatorComponent implements OnInit {
  @Input() refId: string = '67b9b98bce8ad00001e43b9a';
  @Input() showPersonalizedQuote = true;
  @Input() lpSupportEmail = '';
  
  homePrice: number = 350000;
  downPayment: number = 150000;
  interestRate: number = 6.875;
  principal: number = 240000;
  monthlyPayment: number = 1077.71;
  monthlyPrincipal: number = 666.67;
  homeInsuranceRate: number = 0.45;
  propertyTaxRate: number = 0.9;
  apr: number = 6.947;
  min = 50000;
  tenureInYears: number = 30;
  bsModalRef: BsModalRef;
  downPaymentMax: number = this.homePrice * 0.75;
  criteriaList = [];
  scenarios = [];
  companyId = '';
  desiredSteps = 20;

  public doughnutChartData: number[] = [];

  constructor(private modalService: BsModalService,
    private activatedRoute: ActivatedRoute,
    private pricingService: PricingService,
    config: NgbCarouselConfig,
  ) { 
    config.showNavigationArrows = true;
		config.showNavigationIndicators = true;
  }

  ngOnInit() {
    this.calculateMortgage();
    this.updateChartData();
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['refId']) {
        this.refId = params['refId'] || '67b9b98bce8ad00001e43b9a';
        this.searchRates();
      }
      if (params['showPersonalizedQuote']) {
        this.showPersonalizedQuote = params['showPersonalizedQuote'] === 'true';
      }
      if (params['lpSupportEmail']) {
        this.lpSupportEmail = params['lpSupportEmail'] || '';
      }
    });
    this.searchRates();
  }

  get homeInsuranceAmount() {
    return this.homePrice * this.homeInsuranceRate / 100 / 12;
  }

  get propertyTaxAmount() {
    return Math.round(this.homePrice * this.propertyTaxRate / 100 / 12);
  }

  get monthlyPaymentTotal() {
    return this.monthlyPayment + this.homeInsuranceAmount + this.propertyTaxAmount;
  }

  get stepSize() {
    return Math.max(100, Math.round(this.downPaymentMax / this.desiredSteps));
   } 
  
  downPayPercentage() { 
  return (+this.downPayment / +this.homePrice) * 100 || 0;
  }

  updateHomePrice(event: string) {
    const prevPercentage = this.downPayPercentage();
    this.homePrice = +event;
    this.downPayment = Math.round(+prevPercentage * +this.homePrice / 100);
    this.downPaymentMax = this.homePrice * 0.75;
    this.calculateMortgage();
    this.updateChartData();
  }

  updateDownPayment(event?: any) {
    this.downPayment = +event;
    this.calculateMortgage();
    this.updateChartData();
  }

  calculateMortgage() {
    const loanAmount = this.homePrice - this.downPayment;
    const monthlyInterestRate = this.interestRate / 100 / 12;
    const numberOfPayments = this.tenureInYears * 12; // 30 years mortgage
    this.principal = loanAmount;
    this.monthlyPayment = (loanAmount * monthlyInterestRate) / (1 - Math.pow(1 + monthlyInterestRate, -numberOfPayments));
    this.monthlyPrincipal = loanAmount / numberOfPayments;
  }

  updateChartData() {
    this.doughnutChartData = [
      Math.round(this.monthlyPayment),
      Math.round(this.homeInsuranceAmount),
      Math.round(this.propertyTaxAmount)
    ];
  }

  get legends() {
    return [
      { label: 'Principal & Interest', color: '#00BCD5', value: this.monthlyPayment },
      { label: 'Home Insurance', color: '#FF9801', value: this.homeInsuranceAmount },
      { label: 'Property Tax', color: '#FFC208', value: this.propertyTaxAmount },
      ];
  }

  openAdvanceModal() {
    const initialState: any = {
      refId: this.refId,
      criteriaList: this.criteriaList,
      scenarios: this.scenarios,
      companyId: this.companyId
    };
    this.bsModalRef = this.modalService.show(AdvanceMortgageCalculatorComponent,
      {
        class: 'modal-xl',
        animated: true,
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
        initialState
      }
    );
  }

  updateFields(rateData) {
    this.apr = rateData.apr;
    this.interestRate = rateData.adjustedRates;
    this.tenureInYears = rateData.term;
    this.calculateMortgage();
    this.updateChartData();
  }

  getRateList(payload?: any) {
    this.pricingService.search(payload).toPromise()
      .then(data => {
        this.criteriaList = data;
        if(data.length && data[0].length) {
        const rateCard = data[0][0];
        this.updateFields(rateCard);
        }
      })
      .catch(err => {
        console.error(err);
      });
  }

  searchRates() {
    this.pricingService.getSearch(this.refId).toPromise()
      .then(ref => {
        this.companyId = ref.company.id;
        this.scenarios = ref.miniPricerPref.search.loanCriterias;
        this.getRateList(ref);
      })
      .catch(err => {
        console.error(err);
      });
  }

}